import Dexie from 'dexie';
import 'dexie-export-import';

// Initialize the database
export const db = new Dexie('CalorieAIDB');

// Define the schema
db.version(1).stores({
  // foodRecords: primary key is id, index on date string for easy filtering, meal_type for statistics
  foodRecords: 'id, date, meal_type, recorded_at',
  
  // goals: primary key is id, index on is_active to quickly find the active goal
  goals: 'id, is_active',
  
  // foodDatabase: primary key is id, index on category and name for fast search
  foodDatabase: 'id, category, name',
  
  // customFoods: primary key is id
  customFoods: 'id, name',
  
  // weightRecords: primary key is id, index on recorded_at to sort easily
  weightRecords: 'id, recorded_at'
});
